import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

const EditFoto = () => {
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [imageUrl, setImageUrl] = useState([]);
  const { id } = useParams();

  const handleCancel = () => {
    navigate("/admin/foto");
  };

  const handleFileChange = async (event) => {
    const files = event.target.files;
    const url = [];

    if (files.length > 0) {
      try {
        for (const file of files) {
          const formData = new FormData();
          formData.append("file", file);

          const response = await axios.post(
            `/api_w/upload/multiple`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                db_name: process.env.REACT_APP_DB_NAME,
              },
            }
          );

          const uploadedImageUrl = response.data.data[0].Location;
          url.push(uploadedImageUrl);
        }

        setImageUrl(url);
      } catch (error) {
        toast.error(
          "Error Upload Gambar: " +
            (error.response?.data?.message || error.message)
        );
      }
    }
  };

  useEffect(() => {
    const fetchFotoData = async () => {
      try {
        const response = await axios.get(`/api_w/galleries/${id}`, {
          headers: {
            db_name: process.env.REACT_APP_DB_NAME,
          },
        });
        const foto = response.data.data;
        setTitle(foto.title);
        const urls = foto.url ? foto.url.split(",") : [];
        setImageUrl(urls);
      } catch (error) {
        toast.error(
          "Error fetching foto data: " +
            (error.response?.data?.message || error.message)
        );
      }
    };

    fetchFotoData();
  }, [id]);

  const handleSubmit = async () => {
    try {
      const response = await axios.put(
        `/api_w/galleries/${id}`,
        {
          title,
          url: imageUrl,
          type: "image",
        },
        {
          headers: {
            Authorization: `${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
            db_name: process.env.REACT_APP_DB_NAME,
          },
        }
      );
      console.log(response.data);
      toast.success("Berhasil Edit Foto!");
      navigate("/admin/foto");
    } catch (error) {
      toast.error(
        "Error Edit Foto: " + (error.response?.data?.message || error.message)
      );
    }
  };

  return (
    <div className="p-5">
      <div className="mb-4">
        <label className="text-md mb-2 block font-bold text-gray-800 dark:text-white">
          Judul
        </label>
        <input
          type="text"
          id="title"
          name="title"
          className="block w-full rounded-md border-2 border-gray-300 px-3 py-2 shadow-sm outline-none"
          placeholder="Judul"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
      </div>
      <div className="mb-4">
        <label className="text-md block font-bold text-gray-800 dark:text-white">
          Gambar
        </label>
        {imageUrl.length > 0 && (
          <div className="mt-2 flex gap-4 dark:text-white">
            {imageUrl.map((url, index) => (
              <img key={index} src={url} alt="title" className="h-24 w-24 rounded-md" />
            ))}
          </div>
        )}
        <input
          type="file"
          id="img"
          name="img"
          accept="image/*"
          multiple
          className="w-full rounded border px-3 py-2 dark:text-white"
          onChange={handleFileChange}
        />
        <span className="ml-1 mt-0 block text-xs text-gray-600">
          *Max size: 5MB, Format: .png, .jpg, .jpeg, .svg, .webp
        </span>
      </div>
      <div className="flex justify-end gap-4">
        <button
          type="button"
          className="rounded bg-red-500 py-2 px-4 font-bold text-white"
          onClick={handleCancel}
        >
          Batal
        </button>
        <button
          type="button"
          className="rounded bg-green-600 py-2 px-4 font-bold text-white"
          onClick={handleSubmit}
        >
          Edit
        </button>
      </div>
    </div>
  );
};

export default EditFoto;
